import React from 'react';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface ScheduleSectionProps {
    actions?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    collapsed: boolean;
    label: string;
    onToggle: () => void;
    total: number;
}

export const ScheduleSection: React.FC<ScheduleSectionProps> = ({
    actions, children, className = 'schedule-time-group', collapsed, label, onToggle, total,
}) => {
    const { t } = useTranslation();
    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
        }
    };
    return (
        <section className={`${className} ${collapsed ? 'is-collapsed' : 'is-expanded'}`}>
            <div className="schedule-date-header schedule-date-header-with-actions"
                role="button" tabIndex={0} aria-expanded={!collapsed} onClick={onToggle} onKeyDown={onKeyDown}>
                <div className="schedule-header-title">
                    <span>{label}</span>
                    <span className="schedule-header-count">{total}</span>
                </div>
                <div className="schedule-header-actions" onClick={(event) => event.stopPropagation()}>
                    <button type="button" className="schedule-collapse-button" onClick={onToggle}
                        aria-label={collapsed ? t('dailyPlanner.expand') : t('dailyPlanner.collapse')} aria-expanded={!collapsed}>
                        <FontAwesomeIcon icon={collapsed ? faChevronRight : faChevronDown} />
                    </button>
                    {actions}
                </div>
            </div>
            {!collapsed && children}
        </section>
    );
};
